import React from 'react';
import { MdScience } from 'react-icons/md';
import BaseRunDialog, { type BaseRunDialogProps } from './BaseRunDialog';

export type TestRunDialogProps = Omit<
  BaseRunDialogProps,
  'title' | 'subtitle' | 'icon' | 'submitLabel'
> & { dataTestId?: string };

/**
 * Modal that collects {@link RunInputValue} bindings for every Input node
 * before kicking off a full-graph test run.
 *
 * Thin wrapper around {@link BaseRunDialog} — only the title / subtitle /
 * icon / submit label differ from the production {@link RunDialog}.
 */
const TestRunDialog: React.FC<TestRunDialogProps> = (props) => (
  <BaseRunDialog
    {...props}
    title="Test run"
    subtitle="Provide inputs and start a test run. Test runs use the same engine as production runs but are scoped to your draft."
    icon={<MdScience />}
    submitLabel="Start test run"
    dataTestId={props.dataTestId ?? 'test-run-dialog'}
  />
);

export default TestRunDialog;
